import { apiClient } from './client'
import type { ApiResponse } from './client'
import type { SendingDomainViewDto, SendingDomainCreateDto, ConfigureTrackingDto } from '@/types/sendingDomains'

export const sendingDomainsApi = {
  list: (clientCompanyId: string): Promise<ApiResponse<SendingDomainViewDto[]>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/SendingDomains`),

  get: (clientCompanyId: string, id: string): Promise<ApiResponse<SendingDomainViewDto>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/SendingDomains/${id}`),

  create: (clientCompanyId: string, dto: SendingDomainCreateDto): Promise<ApiResponse<SendingDomainViewDto>> =>
    apiClient.post(`/api/ClientCompanies/${clientCompanyId}/SendingDomains`, dto),

  remove: (clientCompanyId: string, id: string): Promise<ApiResponse<null>> =>
    apiClient.delete(`/api/ClientCompanies/${clientCompanyId}/SendingDomains/${id}`),

  // Triggers a DNS re-check in Resend and returns the refreshed status + records.
  verify: (clientCompanyId: string, id: string): Promise<ApiResponse<SendingDomainViewDto>> =>
    apiClient.post(`/api/ClientCompanies/${clientCompanyId}/SendingDomains/${id}/Verify`, {}),

  // Read-through status refresh (re-syncs from Resend without re-triggering verification).
  status: (clientCompanyId: string, id: string): Promise<ApiResponse<SendingDomainViewDto>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/SendingDomains/${id}/Status`),

  // Configures open/click tracking (and an optional custom tracking subdomain); returns the
  // refreshed domain, whose DnsRecords now include the generated tracking CNAME.
  configureTracking: (clientCompanyId: string, id: string, dto: ConfigureTrackingDto): Promise<ApiResponse<SendingDomainViewDto>> =>
    apiClient.post(`/api/ClientCompanies/${clientCompanyId}/SendingDomains/${id}/Tracking`, dto),

  // Marks this domain as the company default (auto-selected for activations + test sends). The target
  // must be Verified; the previous default is cleared server-side. Returns the updated domain.
  setDefault: (clientCompanyId: string, id: string): Promise<ApiResponse<SendingDomainViewDto>> =>
    apiClient.post(`/api/ClientCompanies/${clientCompanyId}/SendingDomains/${id}/Default`, {}),
}
